import { type ReactNode } from 'react';
import { cn } from '../lib/cn';

/**
 * ModernSettingsRow — one labeled row inside a ModernSettingsSection.
 * Label + optional description on the left, a control (switch, button,
 * select, badge, …) on the right. Consistent height and padding so stacked
 * rows read like a clean table.
 */
export function ModernSettingsRow({
  label,
  description,
  control,
  htmlFor,
  className,
}: {
  label: ReactNode;
  description?: ReactNode;
  control?: ReactNode;
  htmlFor?: string;
  className?: string;
}) {
  const LabelTag = htmlFor ? 'label' : 'div';
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-4 px-5 py-3.5 transition-colors hover:bg-muted/30',
        className,
      )}
    >
      <LabelTag htmlFor={htmlFor} className="min-w-0 cursor-default">
        <div className="text-[13px] font-medium text-foreground">{label}</div>
        {description && (
          <div className="mt-0.5 text-[12px] leading-relaxed text-muted-foreground">
            {description}
          </div>
        )}
      </LabelTag>
      {control && <div className="flex flex-shrink-0 items-center gap-2">{control}</div>}
    </div>
  );
}
